import { Auth } from "aws-amplify";

export const HUMANIZE_STREAM_URL = process.env.NEXT_PUBLIC_HUMANIZE_STREAM_URL;

/**
 * SigV4-signed fetch to the humanize-again streaming Lambda Function URL.
 * Returns the raw Response so the caller can stream via response.body.getReader().
 *
 * The body passed to the signer must be byte-identical to the body sent in
 * fetch() -- otherwise SigV4 fails with SignatureDoesNotMatch. We stringify
 * once and reuse the resulting payload string for both.
 */
export async function signedHumanizeFetch(body: object): Promise<Response> {
  // Dynamic require matches the existing scraper-instructions pattern
  // (keeps AWS SDK out of the Next.js SSR bundle).
  const { SignatureV4 } = require("@aws-sdk/signature-v4");
  const { Sha256 } = require("@aws-crypto/sha256-browser");
  const { HttpRequest } = require("@aws-sdk/protocol-http");

  const credentials = await Auth.currentCredentials();
  const u = new URL(HUMANIZE_STREAM_URL);
  const payload = JSON.stringify(body);

  const request = new HttpRequest({
    method: "POST",
    hostname: u.hostname,
    path: u.pathname || "/",
    headers: {
      "Content-Type": "application/json",
      host: u.hostname,
    },
    body: payload,
  });

  const signer = new SignatureV4({
    credentials,
    region: process.env.NEXT_PUBLIC_AWS_REGION || "eu-central-1",
    service: "lambda",
    sha256: Sha256,
  });

  const signedRequest = await signer.sign(request);

  // Browsers forbid setting the host header on fetch.
  const headersForRequest = { ...signedRequest.headers };
  delete headersForRequest.host;

  return fetch(HUMANIZE_STREAM_URL, {
    method: "POST",
    headers: headersForRequest as HeadersInit,
    body: payload,
  });
}
